import React from 'react';
import { LeadForm } from '../../components/LeadForm';
const PROGRAM_OPTIONS = ['Kids Taekwondo', 'Mini Troopers', 'Adult Classes', 'Family Classes', 'Self-Defense', 'Summer Camp', 'General Question'] as const;
export function DoSomeMartialArtsHeroForm() {
  return <div className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative" data-id="element-951">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-952">
        Find the Right Class or Program
      </div>
      <div className="mt-4" data-id="element-953">
        <LeadForm buttonText="Check Availability" programOptions={PROGRAM_OPTIONS} helperText="A Storm coach will help you pick the right starting class based on your age and goals." data-id="element-954" />
      </div>
    </div>;
}